<template>
  <div class="hpProtips reveal">
    <!-- <div class="hpSecTitle" style="font-weight:500 !important;">Conical Connection Implants</div> -->
    <div class="hpSecTitle">
      <div class="hpProIcon"><img :src="getIcon" /></div>
      <span>{{localize('experts_protips')}}</span>
      <!-- debug:{{SCROLLX}} -->
    </div>

    <div class="hpSecSub">
      <router-link :to="getMainPageLink">
        {{localize('what_do_the_pros_say')}} - <span>{{localize('view_all')}}</span>
      </router-link>
    </div>
    
    <!-- , activeIndex == -1 ? '':'active' ['hptVideoWrapper','pt-xl']">-->
    <div :class="['hptVideoWrapper pt-xl',activeIndex == -1 ? '':'active']">
        <div class="hptVideoFrame" v-if="activeIndex>-1">
          <iframe width="100%" height="100%"
            :src="videoFrameURL"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen>
          </iframe>          
        </div>
    </div>

    <!-- component of pro tips proData-->
    <div :class="['tipBoxes theme-light',activeIndex == -1 ? '':'active']">
      <div class="tipsScroller" ref="tipsScrolledElements">
      <ul>
        <li v-for="(item,index) in proData" 
          :class="['probox','probox'+index, activeIndex==index ? 'active':'']" :key="'probox_'+index">

          
          <a @click="activeIndex = index">
            <div class="tipPopSep" :style="'--index:'+index"><div class="sepInline"></div></div>
            <div class="tipBotSep" :style="'--index:'+index"><div class="sepInline"></div></div>

            <!-- <div class="pbName hpFont1">{{emphesizeDoctorName(item.subtitle)}}</div> -->
            <!-- <div class="pbName hpFont1">{{item.subtitle}}</div> -->

            <div class="pbImg" :style="'--index:'+index">
              <img  :src="'https://mis-implants.com/upload/'+item.img">
            </div>            

            <div class="pbTitle hpFont15 fadeUpItem" :style="'--addDelay:0.3s;--index:'+index" :title="item.title" v-html="emphesizeDoctorName(item.title)"></div>
            <div class="pbWatch hpFont1 fadeUpItem" :style="'--addDelay:0.4s;--index:'+index"><i class="fal fa-play"></i><span>{{localize('watch_video')}}</span></div>



          </a>
        </li>        
      </ul>
      </div>
    </div>

      <div class="tipsPager">
          <!-- itemsPerPage={{itemsPerPage}} -->
          <sidepager
              @item-change = "onPagerChange"
              :skinMode="0"
              :itemIndex="currentPage" 
              :itemsPerPage="itemsPerPage"
              :mobilePagesCount = "5"
              :items="proData">
              
          </sidepager>
      </div>


<!--     <abtn style="float:right;" color="blue" :class="['self-end']" mini>
      <span style="font-weight:400 !important;">More Tips</span>
    </abtn>    
 -->  
    </div>
</template>

<script>
import sidepager from "@/views/com/sidepager.vue";
import { mapState, mapGetters, mapActions } from "vuex";
/* import hpAccordion from "./comp/hpAccordion.vue"; */

export default {
  props: {
    sectionData:{}
  },
  components: { sidepager },
  data() {
    return {
        SCROLLX:'-',
        itemsPerPage:4,
        currentPage:-1,
        activeIndex: -1,
        __activeIndex:-1,
        __proData:
        [
          {
            "title":"Importance of Surgical Guides",
            "subtitle":"Dr. Kyle Stanley",
            "url":"https://www.youtube.com/embed/3mD20Tz2WJw?si=W2GR_0hxbN7xR6gv",
            "img":"img/temp_icon1.png"
          },
          {
            "title":"How Many Connections Are You Making? (Seattle Study Club)",
            "subtitle":"Dr. Gustavo Giordani",
            "url":"https://www.youtube.com/embed/7tlHYtA6TI4?si=9IMGh85udJJ4UmFa",
            "img":"img/temp_icon1.png"
          },
          {
            "title":"CONNECT System",
            "subtitle":"Dr. David Norre",
            "url":"https://player.vimeo.com/video/778788386?h=e321c4153d",
            "img":"img/temp_icon1.png"
          },
          {
            "title":"Decreasing Bone Loss when Replacing or Restoring Implants (Seattle Study Club)",
            "subtitle":"Dr. Kyle Stanley",
            "url":"https://www.youtube.com/embed/3mD20Tz2WJw?si=lflXvdmnJPOi_YVa",
            "img":"img/temp_icon1.png"
          }
        ]
    };
  },
  mounted() {
    var vm=this;
    //alert(this.proData[this.activeIndex].url);
    this.$nextTick(() => {
      //window.addEventListener('resize', vm.onResize); 
      vm.onResize();     

      var scroller = this.$refs.tipsScrolledElements;
      scroller.addEventListener("scroll", vm.checkScrollPos, false);
    })

  },
  watch: {
  },
  computed: {
    ...mapGetters(["localeString"]),
    getMainPageLink()
    {
      return this.parsedLocaleString+"/education/learn-online/pro-tips";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    getIcon()
    {
      return "/img/icons/svg/lamp.svg";
    },
    videoFrameURL()
    {            
        let elIndex = 0;
        if(this.activeIndex>-1){
          elIndex=this.activeIndex;
        }
        let originalURL = this.proData[elIndex].url;
        let url = this.convertToEmbbedVideoURL(originalURL);
        return url;
    },
    proData()
    {
      return this.sectionData.items;
    }
  },
  methods: {
    checkScrollPos()
    {
      var vm=this;
      var scroller = this.$refs.tipsScrolledElements;
      let scrolledX = scroller.scrollLeft;      
      var scrollerWidth = scroller.getBoundingClientRect().width;
      var scrollerWrapperX = scroller.offsetLeft;      
      var scrolledInnerX = scrolledX - scrollerWrapperX;
      var reveals = scroller.querySelectorAll(".probox");    

      for (var i = 0; i < reveals.length; i++) {

            var pageAnchorElement = i;
            if(this.itemsPerPage>1)
            {
              //none mobile mode
              //we compage the scroll position to each first element of the page 
              //on page 1: element will be 0
              //on page 2: element will be 4
              //on page 3: element will be 8.....
              //pageAnchorElement = Math.floor(i / vm.itemsPerPage);
              //vm.SCROLLX = "anchor:"+pageAnchorElement;              
            }

            //let elOffsetX = reveals[pageAnchorElement].offsetLeft;
            let elOffsetX = reveals[i].offsetLeft;
            let diff = Math.abs(scrolledX-elOffsetX);

            if(this.itemsPerPage>1)
            {
                var isVisible = this.isElementVisible(scroller,reveals[i]);
                if(isVisible){
                  let pageIndexVisible = Math.floor(i/this.itemsPerPage);
                  //console.log("visible page="+pageIndexVisible);
                  vm.currentPage = pageIndexVisible;
                }
            }
            else{                
                if(diff<140){ //mobile mode
                    vm.currentPage = i;//this will update the pager buttons//mobile mode
                }
            }
        }
        if(scrolledX<100){
          vm.currentPage=0;
        }
    },       
    isElementVisible(container, element) 
    {
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        const isVisible = 
        (
            (elementRect.left+(containerRect.width/2)) >= containerRect.left &&
            elementRect.right <= containerRect.right
        );
        return isVisible;
    },
    onResize() 
    {
      var winWidth = window.innerWidth;
      this.scrWidth = winWidth;
      if(this.scrWidth<850)
      {
        this.itemsPerPage = 1;
      }else{
        this.itemsPerPage = 4;
      }
    },    
    onPagerChange(index)
    {
      this.navTo(index);
    },
    navTo(index)
    {
      var indexOfElement = index * this.itemsPerPage;
      let scrollToElement = this.$refs.tipsScrolledElements.getElementsByClassName("probox")[indexOfElement];
      scrollToElement.scrollIntoView(
      { 
          behavior: 'smooth',
          inline:'start',
          block:'nearest' }
      );      
    },    
    emphesizeDoctorName(name)
    {
        var newTitle = name; // Doctor name: Tip name = > <span>Doctor Name:</span> ....
        //return newTitle;
        /////alert("name="+name);
        //return name.indexOf(":");
        if(name.length>3 && name.indexOf(":")>-1)
        {
            var parts = name.split(':');            
            if(parts!= undefined && parts.length>0)
            {
              //return parts.length;
              var temp = "";
              for(var i=0;i<parts.length;i++)
              {                
                  temp = temp + parts[i];
                  if(i==0)
                  {
                    temp = "<span class='emph'>"+temp+":"+"</span> ";
                  }
              }
              if(temp.length>0)
              {
                newTitle = temp;
              }
            }
        }
        return newTitle;
    },
    convertToEmbbedVideoURL(src) {
      if (src.indexOf("vimeo") > -1) {
        let code = src.match(/[0-9]+/g)[0];
        return `https://player.vimeo.com/video/${code}`;
      } else if (src.indexOf("youtu.be") > -1) {
        let code = src.split("/");
        return `https://www.youtube.com/embed/${code[code.length - 1]}`;
      }
      if (src.indexOf("/") < 0) {
        // let code = src.match(/[0-9]+/g)[0];
        return `https://www.youtube.com/embed/${src}`;
      }
      return src;
    }    
  }
};
</script>

<style>
.emph{
  font-weight:500 !important;
  color:#202020;
  }

</style>
<style scoped>
:root
{
  --text-mpl:1px;
}
/* Increase the size of the multiplier on bigger screens */
@media (min-width: 1800px) {
  :root {
    --text-mpl: 1px;
  }
}


/* ------------- Start animations ------------- */
  .hpProtips.reveal .tipBoxes .fadeUpItem{
      opacity: 0;
      transition: all ease 1.1s;
      transition-delay: calc(var(--addDelay) + (var(--index) * 0.2s));
      transform: translateY(10px);
  }
  .hpProtips.reveal.active .tipBoxes .fadeUpItem{
      opacity: 1;
      transform: translateY(0px);
  }
.hpProtips.reveal .tipBoxes ul li a .tipPopSep
{
    transition: all ease 1.2s;
    transition-delay: calc(var(--index) * 0.2s);
    clip-path: inset(0 100% 0 0);
}
.hpProtips.reveal.active .tipBoxes ul li a .tipPopSep
{
    clip-path: inset(0 0 0 0);
}
.hpProtips.reveal .tipBoxes ul li a .tipBotSep
{
    transition: all ease 1.5s;
    transition-delay: calc(0.2s + var(--index) * 0.2s);
    clip-path: inset(0 100% 0 0);
}
.hpProtips.reveal.active .tipBoxes ul li a .tipBotSep
{
    clip-path: inset(0 0 0 0);
}
.hpProtips.reveal .tipBoxes ul li a .pbImg
{
    transition: all ease 1.2s !important;
    transition-delay: calc(0.1s + var(--index) * 0.1s) !important;
    opacity: 0;
}
.hpProtips.reveal.active .tipBoxes ul li a .pbImg
{
    opacity: 1;
}

/*
.hpProtips.reveal .tipBoxes ul li a .pbTitle,
.hpProtips.reveal .tipBoxes ul li a .pbWatch
{
    transition: all ease 1s !important;
    transition-delay: calc(2s + var(--index) * 0.5s) !important;
    opacity: 0;
}
.hpProtips.reveal.active .tipBoxes ul li a .pbTitle,
.hpProtips.reveal.active .tipBoxes ul li a .pbWatch
{
    opacity: 1;
}
*/








.hpProtips
{
  padding-top: 2vw;
  padding-left:10vw;
  padding-right:10vw;
  padding-bottom: 3vw;
  text-align: center;
}
.hpSecTitle
{
  position: relative;
  display: inline-block;
  margin: auto !important;
}
.hpProIcon
{
  position: absolute;
  left: calc(-10px - (3.5vw));
  top: 50%;
}
.hpProIcon img
{
  width: 3.5vw;
  height: auto;
  transform: translateY(-50%);
}

.tipBoxes
{
  clear: both;
  width: 100%;
  height: auto;
  padding: 0px;
  margin: 0px;
}
.tipBoxes .tipsScroller
{
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

}
.tipBoxes .tipsScroller {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.tipBoxes .tipsScroller::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}
.tipBoxes ul
{
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  padding: 0px;
  gap: 10px;
  flex-wrap: wrap;
  margin: 0px;
  width: 240vw; /* 100-20-12vw = 68vw 68*3 pages = 204 total for the whole scroll size */
}
.tipBoxes ul li
{
    flex: 1;
    height: calc(15vw + 40px);
}
.tipBoxes ul li a
{    
    transition: all 1s ease;
    position: relative;    
    top: 0px;
    height: 15vw;
    width: 100%;
    display: block;
    transition:all 0.6s ease-out-quad;
    /* padding:2.5vw 0px;     */
    /* padding:2.5vw 2.5vw; */
    padding:2vw 2.5vw 2.5vw 0;
    text-align: left;
    cursor: pointer;
    min-height: 120px;
    
}

.tipBoxes ul li a .tipPopSep
{
  position: absolute;
  top: 0px;
  width: 100%;
  height: 1px;
}
.tipBoxes ul li a .tipPopSep .sepInline
{
  width: 100%;
  height: 1px;
  border-top: solid 1px #eaeaea;
  transition: all ease 0.4s;
}
.tipBoxes ul li a .tipBotSep
{
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 4px;
}
.tipBoxes ul li a .tipBotSep .sepInline
{
  width: 100%;
  height: 4px;
  border-bottom: solid 4px #eaeaea;
  transition: all ease 0.4s;
}




@media (hover: hover) {
  /* .tipBoxes ul li.active a   */
  .tipBoxes ul li a:hover
  {
      top: -5px;
      height: calc(15vw + 20px);
  }
  .tipBoxes.theme-light ul li a:hover .tipBotSep .sepInline
  {    
      border-bottom: solid 4px #09b6f4; 
  }
}

.tipBoxes.theme-light ul li.active a .tipBotSep .sepInline
{    
    border-bottom: solid 4px #09b6f4; 
}



/* //////////// theme dark //////////// */
/* //////////// theme dark //////////// */
/* //////////// theme dark //////////// */
.tipBoxes.theme-dark ul li a
{    
    background-image: linear-gradient( -39deg, rgb(3,52,92) 0%, rgb(14,105,167) 100%);
    color:#fff;
}
.tipBoxes.theme-dark ul li a:hover
{
    background-image: linear-gradient( -39deg, rgb(3,52,92) 0%, rgb(14,105,167) 100%);
}
.tipBoxes.theme-dark ul li a .pbName{color: #b3e4ff;}
.tipBoxes.theme-dark ul li a .pbTitle{color: #fff;}
.tipBoxes.theme-dark ul li a .pbWatch{color: #b3e4ff;}





/* //////////// theme light //////////// */
/* //////////// theme light //////////// */
/* //////////// theme light //////////// */
.tipBoxes.theme-light ul li a
{    
    background-color: #fff;color:#333333;
    /* border-bottom: solid 4px #eaeaea; */
    /* border-top: solid 1px #eaeaea; */
    margin-top: 10px;
}
.tipBoxes.active.theme-light ul li a
{
  border-top: solid 0px #eaeaea;
}
.tipBoxes.theme-light ul li a:hover
{
    background-color: #fff;
}
.tipBoxes.theme-light ul li a .pbName{color: #333333;}
.tipBoxes.theme-light ul li a .pbTitle{color: #333333;}
.tipBoxes.theme-light ul li a .pbWatch{color: #1894e2;}



.pbIcon{text-align: left;}
.pbIcon img
{
    height: 4vw;width: auto;  
}
.pbName
{
    font-size:12px;
    text-align: left;
    font-weight: 300 !important;
    padding-top: 6px;
}
.pbTitle
{
    text-align: left;
    font-size:20px;
    font-weight:400 !important;
    letter-spacing: -1px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    padding-top: clamp(8px,0.8vw,30px);
}
.pbImg
{
  width: 4vw;
  height: 4vw;
  overflow: hidden;
  position: relative;
  border-radius: 3vw;
}
.pbImg img
{
  position: absolute;
  width: auto;
  height: 4vw;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);

}


.pbWatch
{
  padding-top: 8px;
  text-align: left;
  font-weight: 500 !important;
  opacity: 1;
  transition: all ease 0.5s;
}
.pbWatch span
{
  padding-left: 5px;
  font-weight: 400 !important;
}

.tipBoxes ul li a:hover .pbWatch{
  opacity: 1;
}
.hptVideoWrapper
{
  width: 100%;
  height: 0px;
  border-radius: 25px;
  transition: all ease 1s;
  transition-delay: 0.2s;
}
.hptVideoWrapper.active
{
  height: 50vw;
}

.hptVideoFrame
{
  width: 100%;
  height: 100%;
  border-radius: 25px;
}
.hptVideoFrame iframe
{
  border-radius: 25px;
}

.tipsPager
{
    padding: 1vw 0 2vw 0;
    clear: both;
    margin: auto;
    display: block;
    width: 66px;
    position: relative;
}


    @media screen and (max-width: 815px)
    {
      .hpProtips
      {
        padding-top: 16vw;
      }      
      .hpProIcon{
        display: none;
        left: calc(-10px - (7vw));
      }
      .hpProIcon img{
        width: 7vw;
      }      
      .tipBoxes{
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        width: 70vw;
        margin: auto;
      }
      .tipBoxes ul{
        width: 350vw; /* //70vw*5 items */        
      }
      .tipBoxes ul li{
          height: 70vw;
          scroll-snap-align:start;
      }
      .tipBoxes ul li:nth-child(n+6){
        display: none;
      }      

      .tipBoxes ul li a{
          height: auto;
          padding: 5vw 2.5vw 7vw 0;
          min-height: 67vw;
      }
      .hptVideoWrapper.active{
          height: 60vw;
      }      
      .pbImg{
          width: 28vw;
          height: 28vw;
          border-radius: 28vw;
      }      
      .pbImg img{
          height: 28vw;
      }      
      .pbWatch
      {
        padding-top: 15px;
      }
      .tipsPager
      {
        padding-top:15px;
        padding-bottom: 0px;
        display: block;
        width: 100px;
        margin: auto;
      }      

    }



</style>


